const headRowsExpiredServices = {
  date: 'Data do vencimento',
  equipmentEquipmentParamName: 'Equipamento',
  inspection: 'Tipo de Serviço',
  placeName: 'Local',
};

export default headRowsExpiredServices;
